import { render, staticRenderFns } from "./manage-all-items.vue?vue&type=template&id=6c69a512"
import script from "./manage-all-items.vue?vue&type=script&lang=js"
export * from "./manage-all-items.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports